export default [
  // 运单系统-运单详情
  {
    path: '/waybill/details/:orderCode',
    name: 'WaybillDetails',
    component: () => import('@/views/waybill/details/index.vue'),
    meta: {
      title: '运单详情',
    },
  },
];
